@if (CanReview()) {
  <header class="list-header">
    <div><h2>{{listTitle}}</h2>@if (!loading && !errorMessage) {<p class="list-count">{{topics?.length || 0}} {{(topics?.length === 1 ? singular : listTitle).toLowerCase()}}</p>}</div>
    @if (CanAdminister()) {
      <button type="button" class="list-button" (click)="adding ? closeDetail() : addTopic()">
        <svg class="cms-icon" aria-hidden="true" focusable="false"><use [attr.href]="'/images/cms-actions.svg#' + (adding ? 'close' : 'edit')"></use></svg>
        {{adding ? 'Cancel new ' + singular.toLowerCase() : 'New ' + singular.toLowerCase()}}
      </button>
    }
  </header>
  @if (adding) {<div class="new-topic"><topic-detail [inserting]="true" [programmes]="programmes" [type_id]="topicTypeID" (closeDetail)="closeDetail()"></topic-detail></div>}
  @if (loading) {<p class="list-state" role="status">Loading {{listTitle.toLowerCase()}}…</p>}
  @else if (errorMessage) {<div class="list-state error" role="alert"><p>{{errorMessage}}</p><button class="list-button" (click)="loadTopics()">Retry</button></div>}
  @else if (!topics?.length) {<p class="list-state" role="status">No {{listTitle.toLowerCase()}} available.</p>}
  @else {
    <ul class="entity-list">
      @for (topic of topics; track topic.id) {
        <li class="entity-tile">
          <div class="tile-heading"><h3><a [routerLink]="['/review/responses/topic/', topic.id]">{{topic.topic?.trim() || 'Untitled ' + singular.toLowerCase()}}</a></h3><span class="status" [class.inactive]="!topic.active">{{topic.active ? 'Active' : 'Inactive'}}</span></div>
          <dl class="tile-meta">
            <div><dt>Programme</dt><dd>{{topic.programme_name?.trim() || 'Not available'}}</dd></div>
            <div><dt>Responses</dt><dd>{{topic.response_count ?? 'Not available'}}</dd></div>
            <div><dt>{{singular}} ID</dt><dd>{{topic.id}}</dd></div>
          </dl>
        </li>
      }
    </ul>
  }
} @else {<p class="list-state">Not a reviewer.</p>}
